/**
 * Progenex Blogs mega-menu filter fix (unpublished theme only when this asset is present).
 * Replaces Buddha static Blogs shelves with Liquid-fed recent articles per blog.
 * Left rail News / Recipes / Science act as filters; skip articles without images.
 */
(function () {
  'use strict';

  var DATA_ID = 'prgnx-blogs-megamenu-data';
  var PATCHED = 'data-prgnx-blogs-mm-patched';
  var MAX_TRIES = 40;
  var TRY_MS = 250;

  function readData() {
    var el = document.getElementById(DATA_ID);
    if (!el) return null;
    try {
      return JSON.parse(el.textContent || '{}');
    } catch (e) {
      return null;
    }
  }

  function escapeHtml(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function escapeAttr(s) {
    return escapeHtml(s).replace(/'/g, '&#39;');
  }

  function findBlogsItem(root) {
    var items = (root || document).querySelectorAll('.buddha-menu-item');
    for (var i = 0; i < items.length; i++) {
      var a = items[i].querySelector(':scope > a');
      if (!a) continue;
      var label = (a.getAttribute('aria-label') || '').trim().toLowerCase();
      var title = '';
      var tEl = a.querySelector('.mm-title');
      if (tEl) title = (tEl.textContent || '').trim().toLowerCase();
      if (label === 'blogs' || label === 'learn' || title === 'blogs' || title === 'learn') {
        return items[i];
      }
    }
    return null;
  }

  function tabKeyFromLabel(label) {
    var l = (label || '').trim().toLowerCase();
    if (l === 'news') return 'news';
    if (l === 'recipes') return 'recipes';
    if (l === 'science') return 'science';
    return null;
  }

  function buildArticleLi(article) {
    if (!article || !article.image || !article.url || article.url === '#') return '';
    var title = article.title || '';
    var url = article.url;
    var img = article.image;
    var aspect = article.aspect || 1;
    var id = article.id || '';
    var crop = aspect >= 1 ? 'crop-wide' : 'crop-high';
    return (
      '<li role="none" submenu-columns="1" image-type="' +
      crop +
      '" item-type="featured-article" class="prgnx-mm-article">' +
      '<div class="mega-menu-item-container">' +
      '<div class="mm-image-container"><div class="mm-image">' +
      '<a data-href="' +
      escapeAttr(url) +
      '" href="' +
      escapeAttr(url) +
      '" aria-label="' +
      escapeAttr(title) +
      '" data-no-instant="" onclick="mmGoToPage(this, event); return false;" role="none" tabindex="-1">' +
      '<img src="' +
      escapeAttr(img) +
      '" data-src="' +
      escapeAttr(img) +
      '" aspect-ratio="' +
      escapeAttr(aspect) +
      '" class="get-article-image prgnx-mm-img" data-id="' +
      escapeAttr(id) +
      '" alt="' +
      escapeAttr(title) +
      '" loading="lazy">' +
      '</a></div><div class="mm-label-wrap"></div></div>' +
      '<a data-href="' +
      escapeAttr(url) +
      '" href="' +
      escapeAttr(url) +
      '" aria-label="' +
      escapeAttr(title) +
      '" data-no-instant="" onclick="mmGoToPage(this, event); return false;" role="menuitem" class="mm-featured-title">' +
      '<span class="mm-title">' +
      escapeHtml(title) +
      '</span></a>' +
      '</div></li>'
    );
  }

  function replaceTabGrid(tabLi, articles) {
    var grid = tabLi.querySelector(':scope > ul.mm-submenu');
    if (!grid) return 0;
    var html = '';
    var count = 0;
    for (var i = 0; i < articles.length; i++) {
      var piece = buildArticleLi(articles[i]);
      if (piece) {
        html += piece;
        count++;
      }
    }
    grid.innerHTML = html;
    return count;
  }

  function applyPatch(data) {
    var item = findBlogsItem(document);
    if (!item) return false;
    if (item.getAttribute(PATCHED) === '1') return true;

    var topA = item.querySelector(':scope > a');
    var topTitle = topA && topA.querySelector('.mm-title');
    if (data.topLabel && topA && topTitle) {
      topTitle.textContent = data.topLabel;
      topA.setAttribute('aria-label', data.topLabel);
      // Point Learn hub at News (default) blog index
      var newsUrl =
        (data.blogs && data.blogs.news && data.blogs.news.url) || '/blogs/news';
      topA.setAttribute('href', newsUrl);
      topA.setAttribute('data-href', newsUrl);
    }

    var tabbed = item.querySelector(':scope > ul.mm-submenu.tabbed');
    if (!tabbed) return false;

    var tabs = tabbed.querySelectorAll(':scope > li');
    var counts = {};
    var defaultTab = (data.defaultTab || 'news').toLowerCase();
    var defaultLi = null;

    for (var i = 0; i < tabs.length; i++) {
      var li = tabs[i];
      var a = li.querySelector(':scope > a');
      if (!a) continue;
      var label = a.getAttribute('aria-label') || (a.querySelector('.mm-title') || {}).textContent || '';
      var key = tabKeyFromLabel(label);
      if (!key) continue;
      var blog = (data.blogs && data.blogs[key]) || null;
      if (!blog) continue;

      // Ensure tab links to the real blog
      if (blog.url) {
        a.setAttribute('href', blog.url);
        a.setAttribute('data-href', blog.url);
      }

      var n = replaceTabGrid(li, blog.articles || []);
      counts[key] = n;

      if (key === defaultTab) defaultLi = li;
    }

    // Default open: News (or configured defaultTab)
    for (var j = 0; j < tabs.length; j++) {
      tabs[j].classList.remove('tab-opened');
      var ta = tabs[j].querySelector(':scope > a');
      if (ta) ta.setAttribute('aria-expanded', 'false');
    }
    if (!defaultLi && tabs[0]) defaultLi = tabs[0];
    if (defaultLi) {
      defaultLi.classList.add('tab-opened');
      var da = defaultLi.querySelector(':scope > a');
      if (da) da.setAttribute('aria-expanded', 'true');
    }

    // Hide any leftover blank / hash-link cards elsewhere under Blogs
    var bad = item.querySelectorAll(
      '[item-type="featured-article"] a[href="#"], [item-type="featured-article"] a[data-href="#"]'
    );
    for (var k = 0; k < bad.length; k++) {
      var card = bad[k].closest('[item-type="featured-article"]');
      if (card) card.remove();
    }

    item.setAttribute(PATCHED, '1');
    item.setAttribute('data-prgnx-mm-counts', JSON.stringify(counts));
    item.setAttribute('data-prgnx-mm-default', defaultTab);
    window.__prgnxBlogsMegaMenu = { ok: true, counts: counts, defaultTab: defaultTab, topLabel: data.topLabel };
    return true;
  }

  function boot() {
    var data = readData();
    if (!data || !data.blogs) return;
    var tries = 0;
    var timer = setInterval(function () {
      tries++;
      if (applyPatch(data) || tries >= MAX_TRIES) {
        clearInterval(timer);
      }
    }, TRY_MS);

    // Re-apply if Buddha re-inits the menu later
    var obs = new MutationObserver(function () {
      var item = findBlogsItem(document);
      if (item && item.getAttribute(PATCHED) !== '1') {
        applyPatch(data);
      }
    });
    obs.observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
